import { ErrorMessage, Field, Form, FormikProps } from 'formik'
import { withFormik } from 'formik'
import * as React from 'react'
import styled from 'styled-components'
import * as Yup from 'yup'
import { Alert } from '../../atoms/Alert'
import { Button } from '../../atoms/Button'
import { FieldError } from '../../atoms/FieldError'
import { Link } from '../../atoms/Link'
import { FieldInput } from '../../molecules/FieldInput'
import { media } from '../../utils/media'

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'

const translations = {
  'es': {
    emailPlaceholder: 'Correo electrónico',
    passwordPlaceholder: 'Contraseña',
    tooShort: '¡Demasiado corto!',
    wrongUsernamePassword: 'Nombre de usuario o contraseña incorrectos',
    userExpired: 'Lo sentimos, este usuario ha caducado',
    noAdmin: 'Este usuario no es administrador',
    forgotPassword: '¿Olvidaste tu contraseña?',
    loginButton: 'Inicio de sesión',
    required: 'Contraseña',
  },
  'en': {
    emailPlaceholder: 'Email',
    passwordPlaceholder: 'Password',
    tooShort: 'Too short!',
    wrongUsernamePassword: 'Wrong username or password',
    userExpired: 'Sorry, this user is expired',
    noAdmin: 'This user is no admin',
    forgotPassword: 'Forgot password?',
    loginButton: 'LOG IN',
    required: 'Required',
  },
}

export interface IFormValues {
  username: string
  password: string
}

export interface IViewProps {
  is: null | 'loading' | 'wrongUsernamePassword' | 'userExpired' | 'noAdmin' | 'error' | 'success'
  doSignIn: (values: IFormValues) => void
}

const LoginFormViewInner = ({ is }: FormikProps<IFormValues> & IViewProps) => (
  <Form>
    <Field name="username" placeholder={translations[lang].emailPlaceholder} style={{ marginTop: 20 }} component={FieldInput} />
    <ErrorMessage name="username" component={FieldError} />
    <Field name="password" placeholder={translations[lang].passwordPlaceholder} type="password" style={{ marginTop: 12 }} component={FieldInput} />
    <ErrorMessage name="password" component={FieldError} />
    {is === 'wrongUsernamePassword' && <Alert>{translations[lang].wrongUsernamePassword}</Alert>}
    {is === 'userExpired' && <Alert>{translations[lang].userExpired}</Alert>}
    {is === 'noAdmin' && <Alert>{translations[lang].noAdmin}</Alert>}
    <LinkContainer><Link to="/forgot-password" style={{ marginTop: 20 }}>{translations[lang].forgotPassword}</Link></LinkContainer>
    <div style={{ marginTop: 20 }}><Button disabled={is === 'loading'} type="submit">{translations[lang].loginButton}</Button></div>
  </Form>
)

const validSignInSchema = Yup.object().shape({
  password: Yup.string().min(8, `${translations[lang].tooShort}`).max(50, 'Too Long!').required(`${translations[lang].required}`),
  username: Yup.string().min(3, `${translations[lang].tooShort}`).max(50, 'Too long').required(`${translations[lang].required}`),
})

export const LoginFormView = withFormik<IViewProps, IFormValues>({
  handleSubmit: async (values, { props, setErrors }) => { await props.doSignIn(values) },
  mapPropsToValues: () => ({ username: '', password: '' }),
  validationSchema: validSignInSchema,
})(LoginFormViewInner)

const LinkContainer = styled.div`
  ${media.tablet`
    float: right;
    margin-top: 18px;
  `}
`



// WEBPACK FOOTER //
// ./src/organisms/LoginForm/LoginFormView.tsx